// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + "031aa83e" + "." + "9c4bd352dd7892e9" + ".js";
};